export const IconFacebook = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 13 24">
    <path d="M12.768 7.465H8.5V5.56c0-.896.594-1.105 1.012-1.105H12.5V.513L8.17.5C4.246.5 3.5 3.439 3.5 5.32v2.145h-3v4h3v12h5v-12h3.85l.418-4z" />
  </svg>
);
